{
    "rapormusteriyetki": {
        "Baslik": "Müşteri Yetki Talebi",
        "Kullanici": "Talep Eden",
        "Tel": "Telefon",
        "Ad": "Ad Soyad",
        "Tarih": "Talep Tarihi",
        "Durum": "Durum",
        "Eslesenler": "Eşleşen Müşteriler",
        "Onayla": "Aktar ve Onayla",
        "Reddet": "Talebi Reddet",
        "Bekleyen": "Bekleyen Talepler",
        "Onaylanan": "Onaylananlar",
        "Reddedilen": "Reddedilenler"
    }
}
